// Importing Styled Components
import styled from '@emotion/styled'
import { BoldHeaderText, paymentBtnStyle, StyledSubmitButton, StyledOneTapPayDownloadButton } from 'portal-modules/payments/components/atoms'

// Importing constants
import { TRANSFERMATE_PAYMENT_METHOD_ID_IMAGE_HEIGHT_ADJUST, TRANSFERMATE_CREDIT_DEBIT_CARD, TRANSFERMATE_BANK_TRANSFER_ID } from 'portal-modules/payments/constants/transfermate'

// Importing components
import ButtonAsExternalLink from 'portal-modules/common/components/ButtonAsExternalLink'
import { Form } from '@entrata/portals-common/lib/components/forms'
import Button from 'portal-modules/common/components/Button'

// Importing utils
import { getEmbeddedViewFlag } from 'portal-modules/common/utils/get-embedded-flag'


export const StyledDiv = styled('div')`
  display: flex;
  height: 100%;
  margin-bottom: 16px;
`
export const StyledBold = styled(BoldHeaderText)`
  margin-bottom: 16px;
  margin: 0;
`

export const StyledDivCard = styled('div')`
  border-radius: 8px;
  padding: 10px 10px 0px 10px;
  margin: 16px 16px 0px 16px;
`

export const StyledImg = styled.img(props => ({
  width: TRANSFERMATE_PAYMENT_METHOD_ID_IMAGE_HEIGHT_ADJUST.includes(props.paymentMethodId) ? '30px' : TRANSFERMATE_CREDIT_DEBIT_CARD === props.paymentMethodId ? '60px' : '30px',
  height: TRANSFERMATE_PAYMENT_METHOD_ID_IMAGE_HEIGHT_ADJUST.includes(props.paymentMethodId) ? '15px' : TRANSFERMATE_CREDIT_DEBIT_CARD === props.paymentMethodId ? '20px' : '22px',
  backgroundColor: TRANSFERMATE_BANK_TRANSFER_ID === props.paymentMethodId ? '#f1f1f1' : 'transparent'
}))

// Payment Redirection page CSS
export const StyledArticle = styled('article')`
  display: flex;
  flex-wrap: nowrap;
  flex-direction: column;
  padding: 16px 28px;
  @media only screen and (max-width: 768px) {
    padding: 16px 0px;
  }
`

export const StyledAlert = styled('div')`
  background-color: #e6f2ff;
  color: black;
  padding: 16px;
  border-radius: 12px;
`

export const StyledInfoIcon = styled('span')`
  position: relative;
  top: 2px;
  margin: 3px 0 0 16px;
  cursor: pointer;
  color: #007aff;
  font-weight: bold;
`
export const StyledCancelButton = styled('a')`
  text-decoration: none;
  margin-left: 20px;
  color: ${({ theme }) => `${theme.blue.base}`};
  @media only screen and (max-width: 768px) {
    margin: 20px 0px;
  }
`
export const StyledTMDirectFlow = styled('StyledPageContent')`
  display: block;
`
export const StyleDocumentUploadWrapper = styled('div')`
  margin: 10px;
  height: 87px;
  flex-direction: column;
  padding: 12px 16px 16px 16px;
  gap: 8px;
  opacity: 0px;
  border: 1px solid;
  border-radius: 16px;
  border-color: #3e3e42;
  box-shadow: 0px 1px 10px 0px #80808014;
  @media only screen and (max-width: 500px) {
    margin: 0px;
    padding-top: 30px;
  }
  @media only screen and (max-width: 360px) {
    margin: 0px;
    padding-top: 30px;
  }
`

export const StyleInstructionWrapper = styled('StyleDocumentUploadWrapper')`
  height: auto;
  font-family: Inter;
  font-size: 13px;
  line-height: 18px;
  letter-spacing: 0.25px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
`

export const StyleRequireDocumentTxt = styled('span')`
  width: 50%;
  height: 27px;
  display: inline-flex;
  gap: 0px;
  opacity: 0px;
  align: right;
  @media only screen and (max-width: 500px) {
    padding-right: 38px;
    display: inline;
  }
  @media only screen and (max-width: 360px) {
    padding-right: 8px;
  }
`
export const StyleDocumentLinkWrapper = styled('span')`
  width: 50%;
  height: 27px;
  display: inline-flex;
  gap: 0px;
  opacity: 0px;
  justify-content: flex-end;
  @media only screen and (max-width: 500px) {
    margin-top: 10px;
    display: inline;
  }
`
export const StyleInstructionTitle = styled('span')`
  margin: 32px 32px;
  width: 198px;
  height: 30px;
  gap: 0px;
  opacity: 0px;
  font-family: Inter;
  font-size: 18px;
  font-weight: 700;
  line-height: 40px;
  letter-spacing: 0.5px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  @media only screen and (max-width: 500px) {
    margin: 0px;
  }
`

export const StyleButtonAsExternalLink = styled(ButtonAsExternalLink)`
  @media only screen and (max-width: 500px) {
    margin-top: 10px;
    height: 40px;
    padding: 10px;
  }
  margin-top: 7px;
`

export const uploadButtonStyle = styled(paymentBtnStyle)`
  @media only screen and (max-width: 500px) {
    width: 100%;
    padding: 10px 10px;
    height: 48px;
  }
`
// Eof - Payment Redirection page CSS

export const LedgerUploadLink = styled(ButtonAsExternalLink)`
  padding: 10px 12px;
  font-size: 10px;
  margin: 0px;
  &:hover {
    white-space: nowrap;
  }
  @media only screen and (max-width: 767px) {
    width: max-content;
    margin: 0;
    padding: 10px;
    font-size: 10px;
  }
  @media only screen and (min-width: 768px) and (max-width: 1024px) {
    width: max-content;
  }
`

export const StyledTableTM = styled('table')`
  width: 100%;
`

export const StyledPendingBankTransferPaymentArticle = styled('article')`
  display: flex;
  gap: 10px;
  align-self: stretch;
  align-items: flex-start;
  background: ${({ theme }) => theme.mode.isDark ? '#7A6305' : '#FDF4CE'};
  border-radius: 8px;
  padding: 10px;
  margin: 10px 0;
`

export const StyledPendingBankTransferPaymentSpan = styled('article')`
  border: solid 1px transparent;
  background-color:  ${({ theme }) =>
    theme.mode.isDark ? '#7A6305' : '#FDF4CE'};
  padding: 5px;
  margin-top: 5px;
  border-radius: 8px;
  width: max-content;
`

export const StyledPhoneNumberFormRow = styled(Form.Row)`
  height: 90px;
`
export const StyledTransferMateTermsConditionsLink = styled('a')`
  text-decoration: none;
  color: ${({ theme }) => theme.blue.system_blue};
`

export const StyledDivider = styled('hr')`
  border: none;
  border-top: 1px solid ${({ theme }) => theme.fields.border};
  margin: 20px 0;
`

export const StyledButton = styled(Button)`
  color: ${({ theme }) => getEmbeddedViewFlag() && theme.embedded.button_text};
`
export const StyledViewInstructionsLink = styled('a')`
  color: ${({ theme }) => theme.blue.system_blue};
  text-decoration: none;
`
export const StyledTransfermatePaymentErrorArticle = styled('article')`
  display: flex;
  flex-wrap: nowrap;
  gap: 10px;
  flex-direction: row;
  padding: 16px 16px;
  background: ${({ theme }) =>
    theme.mode.isDark ? '#561410' : '#F9E2E1'};
  border-radius: 8px;
  @media only screen and (max-width: 768px) {
    padding: 16px 0px;
  }
`
export const StyledButtonWrapper = styled('div')`
  margin-top: 16px;
  @media only screen and (max-width: 768px) {
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-left: 0px;
  }
`
export const StyledTransfermatePaymentBannerText = styled('p')`
  margin: 0px;
`
export const StyledTransfermatePaymentSuccessArticle = styled('article')`
  display: flex;
  flex-wrap: nowrap;
  gap: 10px;
  flex-direction: row;
  padding: 16px 16px;
  background: ${({ theme }) =>
    theme.mode.isDark ? '#184E19' : '#E0F5E0'};
  border-radius: 8px;
  @media only screen and (max-width: 768px) {
    padding: 16px 0px;
  }
`
export const StyledTMReAttemptButton = styled(StyledSubmitButton)`
  margin-left: 0px;
`
export const StyledPaymentMessage = styled('p')`
margin: 0;
`

export const StyledTMInstructionDownloadButton = styled(StyledOneTapPayDownloadButton)`
  margin: 10px 26px;
  width: 185px;
  @media only screen and (max-width: 500px) {
    margin: 10px 0;
  }
`

export const StyledTMInstructionDownloadButtonInModal = styled(StyledOneTapPayDownloadButton)`
  height: 64px;
  width: 100%;
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  justify-content: center;
  font-weight: 600;
  margin: 0;
  margin-top: 16px;
  border-radius: 50px;
`

export const StyledPaymentInstructionsModalFooter = styled('div')`
  display: flex;
  gap: 16px;
`

export const StyledPendingArticle = styled('article')`
  display: flex;
  gap: 10px;
  align-self: stretch;
  align-items: flex-start;
  background: ${({ theme }) => theme.mode.isDark ? '#7A6305' : '#FDF4CE'};
  border-radius: 8px;
  padding: 10px;
  margin: 0px 16px 10px 16px;
`

export const StyledTMDeclarationAmountFormRow = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const StyledTMDeclarationAmountFormRowSpan = styled('span')`
  margin: -10px 0px 16px 0px;
  font-style: italic;
  max-width: 600px;
`